/** Tab row for the product information blocks. Falls back to the first panel when JS is off. */
(function () {
  'use strict';

  if (typeof customElements === 'undefined' || customElements.get('product-info-tabs')) return;

  customElements.define(
    'product-info-tabs',
    class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.prototype.slice.call(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach(
          function (tab, index) {
            tab.addEventListener('click', this.select.bind(this, index));
            tab.addEventListener('keydown', this.onKeydown.bind(this, index));
          }.bind(this)
        );
      }

      onKeydown(index, event) {
        var next = null;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        if (next === null) return;

        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      }

      select(index) {
        this.tabs.forEach(function (tab, i) {
          var active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });

        this.panels.forEach(function (panel, i) {
          var active = i === index;
          panel.classList.toggle('is-active', active);
          if (active) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      }
    }
  );
})();
